"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _droppable = _interopRequireDefault(require("./droppable"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- DRAGDROPCONTEXT : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'DragDropContext',
  props: {
    children: {
      type: 'object',
      default: _react.default.createElement(_droppable.default, {
        droppableId: 'droppable1',
        direction: 'vertical',
        elements: [{
          id: 1,
          position: 0,
          element: "First"
        }, {
          id: 2,
          position: 1,
          element: "Second"
        }]
      })
    }
  }
};
exports.default = _default;